import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import Editar from "../../../icons/editar.svg";
import ModalEditar from "./editarDatosAAFF";
import { getOneAAFF } from "../../../services";
import { UsuarioContext } from "../../../providers/userContext";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { CircularProgress } from "@mui/material";
import { cambiarFormatoNombre } from "../../../functions/funciones";
import { useLocation } from "react-router-dom";
const AAFF = () => {
  const { t } = useTranslation(['aaff', 'common']);
  const user = useContext(UsuarioContext);
  const [aaff, setAaff] = useState({});
  const [modalEditarOpened, setModalEditarOpened] = useState(false);
  const [recargar, setRecargar] = useState(false);
  const [isLoading, setIsLoading] = useState(true)
  const location = useLocation()

  useEffect(() => {
    // fetchData()
    console.log(user)
    getOneAAFF(user.nif).then((res) => {
      res.rol = user.rol
      res.numChildsAAFF = user.numChildsAAFF
      console.log(res)
      setAaff(res);
      setIsLoading(false)
    });
  }, [recargar]);

  return (
    <>
      <ModalEditar
        aaff={aaff}
        opened={modalEditarOpened}
        handleClose={() => {
          setModalEditarOpened(false);
          setRecargar(!recargar);
        }}
      />
      {location.pathname !== '/perfil' &&
        <BreadCrumb rutas={[{path:'/aaff', label: t('titleSingular')}, {path:'/aaff', label:`${aaff.razonSocial}`}]} style={{ margin: '0 10px'}} />
      }
      <div className="listPage">
          <div className="gridCard">
            <div className="gridHead">{t('details.generalInfo')}</div>
            <div className="gridSubhead editarSubhead">
              <div>{t('details.companyData')}</div>
              <div
                className="editarBtn"
                onClick={() => setModalEditarOpened(true)}
              >
                <span style={{ marginRight: 10 }}>{t('common:actions.edit')}</span>{" "}
                <img src={Editar} alt={t('common:actions.edit')} />
              </div>
            </div>
          </div>
      </div>
        <div className="pageContent tableContainer" style={{minHeight: '110px'}}>

          {isLoading ? <CircularProgress style={{ color:'#92004D', position: 'absolute', top: '50%', left: '50%' }} /> :
            <div className="datosGrid">
            <p>
              <b>{t('common:form.name')}:</b> {aaff.razonSocial}
            </p>
            {!aaff.parent_id && (
              <p>
                <b>{t('common:form.nif')}:</b> {aaff.nif}
              </p>
            )}
            <p>
              <b>{t('common:form.city')}:</b> {cambiarFormatoNombre(aaff.municipio)}
            </p>
            <p>
              <b>{t('common:form.province')}:</b> {aaff.provincia}
            </p>
            <p>
              <b>{t('common:form.email')}:</b> {aaff.user?.email}
            </p>
            <p>
              <b>{t('details.contactPerson')}:</b> {aaff.nombreContacto}
            </p>
            <p>
              <b>{t('common:form.phone')}:</b> {aaff.telefono}
            </p>
            </div>
          }
        </div>
    </>
  );
};

export default withRouter(AAFF);
